import { css } from '@emotion/react';
import {
  ContactSideInformation,
  ContactSideInformationProps,
} from '@/components/contact/ContactSideInformation';
import { PageHeader, PageHeaderProps } from '@/components/general/PageHeader';
import { getScreen } from '@/styles/media-query';
import { withPrefix } from 'gatsby';

export type ContactPageTemplateProps = {
  title: PageHeaderProps['title'];
  titleEn: PageHeaderProps['en'];
  titleReadText: PageHeaderProps['readText'];
  sideTitleEn: ContactSideInformationProps['titleEn'];
  sideTitleJa: ContactSideInformationProps['titleJa'];
  sideItems: ContactSideInformationProps['items'];
  children: React.ReactNode;
  type: 'contact' | 'estimate' | 'download' | 'confirm';
};

export const ContactPageTemplate: React.FC<ContactPageTemplateProps> = ({
  title,
  titleEn,
  titleReadText,
  sideTitleEn,
  sideTitleJa,
  sideItems,
  children,
  type,
}) => {
  return (
    <div>
      <PageHeader title={title} en={titleEn} readText={titleReadText}>
        {type !== 'download' ? (
          <div
            css={css`
              pointer-events: none;
              position: absolute;
              right: calc(50% + 256px);
              bottom: -16px;

              @media ${getScreen('pc', '未満')} {
                display: none;
              }
            `}
          >
            <img
              css={css`
                max-width: 100%;
                height: auto;
              `}
              src={withPrefix('/images/faq/header-decoration.png')}
              width="165"
              height="165"
              alt=""
            />
          </div>
        ) : (
          <div
            css={css`
              pointer-events: none;
              position: absolute;
              right: calc(50% + 354px);
              bottom: 2px;

              @media ${getScreen('pc', '未満')} {
                display: none;
              }
            `}
          >
            <img
              css={css`
                max-width: 100%;
                height: auto;
              `}
              src={withPrefix('/images/contact/download-header-decoration.png')}
              width="67"
              height="142"
              alt=""
            />
          </div>
        )}
      </PageHeader>
    {type !== 'download' && type !== 'confirm' && 
      <div
        css={css`
          padding: 32px 30px 0;
          margin: auto;

          @media ${getScreen('pc')} {
            padding: 56px 30px 0;
          }
        `}
      >
        <h2
          css={css`
            margin-bottom: 40px;
            color: #00b3a7;
            text-align: center;
            font: normal normal bold 24px/36px 'Noto Sans JP',sans-serif;
            letter-spacing: 1.2px;
            
            
            @media ${getScreen('pc')} {
            }
          `}
        >
          ご相談の流れ
        </h2>
        <ol
          css={css`
            display: flex;
            justify-content: center;
            gap: 30px 60px;
            color: #00b3a7;
            font: normal normal bold 14px/21px 'Noto Sans JP',sans-serif;
            li {
              text-align: center;
            }
            
            figure {
              margin: 0;
              
              figcaption {
                position: relative;
                display: flex;
                align-items: center;
                
                &::before {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-shrink: 0;
                  width: 40px;
                  height: 40px;
                  margin-right: 16px;
                  border-radius: 9999px;
                  color: #fff;
                  border: 2px solid #fff;
                  outline: 2px solid #00b3a7;
                  background: #00b3a7 linear-gradient(180deg, #00b3a7 0%, #00c9be 100%) 0% 0% no-repeat;
                }
              }
              
              div {
                display: flex;
                align-items: flex-end;
                min-height: 125px;
                justify-content: center;
              }
            }
          `}
        >
          <li><figure>
            <figcaption
              css={css`
                &::before {
                  content: "1";
                }
              `}
            >ご相談内容を入力して、送信してください</figcaption>
            <div><img src={withPrefix('/images/contact/contact-header-step1.png')} width="122" height="89" alt="" /></div>
          </figure></li>
          <li><figure>
            <figcaption
              css={css`
                &::before {
                  content: "2";
                }
              `}
            >担当より確認のお電話をさせていただきます</figcaption>
            <div><img src={withPrefix('/images/contact/contact-header-step2.png')} width="104.5" height="111" alt="" /></div>
          </figure></li>
        </ol>
      </div>
    }
      <div
        css={css`
          max-width: 1060px;
          padding: 32px 30px 0;
          margin: 0 auto;

          @media ${getScreen('pc')} {
            padding: 56px 30px 240px;
            position: relative;
          }
        `}
      >
        <div
          css={css`
            @media ${getScreen('pc')} {
              background: #ffffff;
              max-width: 70%;
              width: 649px;
              box-shadow: 0px 4px 16px #2c28281c;
              border-radius: 12px;
              padding: 48px 40px 56px;
            }
          `}
        >
          {children}
        </div>
        <ContactSideInformation
          titleEn={sideTitleEn}
          titleJa={sideTitleJa}
          items={sideItems}
        />
      </div>
    </div>
  );
};
